import { render, staticRenderFns } from "./ChildSettings.vue?vue&type=template&id=e0d456d2&scoped=true&"
import script from "./ChildSettings.vue?vue&type=script&lang=js&"
export * from "./ChildSettings.vue?vue&type=script&lang=js&"
import style0 from "./ChildSettings.vue?vue&type=style&index=0&id=e0d456d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0d456d2",
  null
  
)

export default component.exports